import createPersistedState from 'vuex-persistedstate'

import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './modules/authentication'
import roles from './modules/roles'
import supplies from './modules/supplies'
import assets from './modules/assets'
import sales from './modules/sales'
import orders from './modules/orders'
import payment from './modules/payment'
import production from './modules/production'
import debts from './modules/debts'
import provider from './modules/providers'
import storehouses from './modules/storehouses'
import cash from './modules/cash';
import mobilities from './modules/mobilities';
import general from './modules/general';
import categories from './modules/categories';
import subunits from './modules/subunits';
import recipes from './modules/recipes';
import products from './modules/products';
import inventories from './modules/inventories';
import units from './modules/units';
import brands from './modules/brands';
import variants from './modules/variants';
import patterns from './modules/patterns';
import colors from './modules/colors';
import reports from './modules/reports';
import importations from './modules/importations';
import voucher from './modules/voucher';

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    state: {

    },
    modules: {
        authentication,
        brands,
        categories,
        colors,
        general,
        roles,
        supplies,
        assets,
        sales,
        mobilities,
        orders,
        patterns,
        payment,
        production,
        debts,
        provider,
        storehouses,
        cash,
        subunits,
        recipes,
        reports,
        products,
        inventories,
        units,
        variants,
        importations,
        voucher
    },
    mutations: {

    },
    actions: {

    },
    plugins: [
        createPersistedState(),
    ]
})